/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import style from './field.module.scss';

const Field = props => {
    const {
        id,
        labelText,
        type,
        placeholder,
        value,
        onChange,
        name,
        maxLength,
        error,
        inputStyle,
        labelStyle,
        min,
        max,
        disabled,
        styles,
    } = props;

    const inputClass = `${inputStyle} ${disabled ? style.disabled : ''}`;
    return (
        <div className={style.inputWrapper}>
            <label className={labelStyle} htmlFor={id}>
                {labelText}
                <input
                    id={id}
                    type={type}
                    className={inputClass}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    name={name}
                    maxLength={maxLength}
                    min={min}
                    max={max}
                    autoComplete="off"
                    disabled={disabled}
                    style={{
                        ...styles,
                        opacity: disabled ? '0.7 !important' : '1 !important',
                    }}
                />
            </label>
            {error ? <div className={style.inputWrapper__invalid}>{error}</div> : null}
        </div>
    );
};

Field.defaultProps = {
    labelText: '',
    placeholder: '',
    value: '',
    name: '',
    maxLength: '',
    min: 0,
    inputStyle: '',
    labelStyle: '',
    error: '',
    onChange: () => {},
    disabled: false,
    styles: {},
};

Field.propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    labelText: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    name: PropTypes.string,
    maxLength: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    error: PropTypes.string,
    inputStyle: PropTypes.string,
    labelStyle: PropTypes.string,
    disabled: PropTypes.bool,
    styles: PropTypes.object,
};

export default Field;
